/* import __COLOCATED_TEMPLATE__ from './no-online-payments.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class SiteBillingPaymentInstrumentPaymentModalNoOnlinePayments extends Component {
  @service currentPractice;
  @service paymentInstrumentModals;
}
